<template>
  <div class="c-passenger-list-item">
    <div class="passenger-info" @click="$emit('select')">
      <template v-if="OrderBusinessType !== 0">
        <div class="checkbox"
             v-show="Passengers && Passengers.map((v) => v.ID).indexOf(item.ID) >= 0"
             :style="{backgroundImage: `url(${require('@/assets/image/base/check-box/not-2.svg')})`}"
        ></div>
        <div
            class="checkbox check-box-default"
            v-show="Passengers && Passengers.map((v) => v.ID).indexOf(item.ID) < 0"
            :style="{backgroundImage: `url(${item.Incomplete ? require('@/assets/image/base/check-box/not-1.svg') : require('@/assets/image/base/check-box/not.svg')})`}"
        ></div>
      </template>
      <div class="details">
        <div class="header">
          <p class="name" v-if="Name"><span>{{ Name }}</span></p>
          <template v-if="Number(TravelType) === 0">
            <template v-if="OrderBusinessType === 1">
              <div class="children" v-if="item.PassengerType === 2">
                {{ $t("Children") }}
              </div>
              <div class="baby" v-if="item.PassengerType === 3">
                {{ $t("Baby") }}
              </div>
            </template>
            <div class="mine" v-if="item.IsCurrentLoginUser">
              {{ $t("Self") }}
            </div>
            <!--<div class="staff" v-if="item.UpType === 1">{{$t('Staff')}}</div>-->
            <div class="no-staff" v-if="item.UpType === 2">
              {{ $t("NonStaff") }}
            </div>
          </template>
          <template v-else-if="Number(TravelType) === 1">
            <template v-if="OrderBusinessType === 1">
              <div class="children" v-if="item.PassengerType === 2">
                {{ $t("Children") }}
              </div>
              <div class="baby" v-if="item.PassengerType === 3">
                {{ $t("Baby") }}
              </div>
            </template>
            <div class="mine" v-if="item.IsCurrentLoginUser">
              {{ $t("Self") }}
            </div>
          </template>
        </div>
        <div class="item" v-if="showCredential">
          <div>{{Credential && Credential.CredentialName || $t('Credential')}} {{Credential && Credential.CredentialNo ? certificatesDes(Credential.CredentialNo) : '--'}}</div>
        </div>
        <div class="item">
          <div>{{ $t("CellphoneNumber") }} {{item.Mobile ? telDes(item.Mobile, item.MobileCountryCode, true) : '--' }}</div>
        </div>
        <div class="item" v-if="showNickName && item.NickName">
          <div>{{ $t("NickName") }} {{ item.NickName }}</div>
        </div>
        <div v-if="item.Incomplete" class="mark">
          <span class="icon" :style="{backgroundImage: `url(${require('@/assets/image/base/warning/icons_12pt_remind_yellow.svg')})`}"></span>
          {{OrderBusinessType === 0 ? title : $t('PleaseCompleteTheInformation_x', 'function', [title || $t('Traveler')]) }}
        </div>
      </div>
    </div>
    <div class="item-edit" @click.stop="$emit('gotoDetails')">
      <!--<p @click.stop="_gotoDetails(index, item)">{{$t('Edit')}}</p>-->
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import mixinDes from "@/common/mixin/passenger/mixin-des";
export default {
  props: {
    OrderBusinessType: {
      type: Number,
      default: 1
    },
    TravelType: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    Passengers: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: ''
    },
    showCredential: {
      type: Boolean,
      default: true
    }
  },
  mixins: [mixinDes],
  computed: {
    Credential() {
      let Credential = null
      let Credentials = this.item.Credentials
      let DefaultCredentialType = this.item.DefaultCredentialType
      if (
          Credentials &&
          Credentials.filter((v) => v.CredentialType === DefaultCredentialType)[0] &&
          Credentials.filter((v) => v.CredentialType === DefaultCredentialType)[0].CredentialNo
      ) {
        Credential = Credentials.filter((v) => v.CredentialType === DefaultCredentialType)[0]
      }
      Credential = Credential || Credentials[0]
      return Credential
    },
    Name() {
      let {ChName, LastName, FirstName, NickName} = this.item
      let EnName = LastName && FirstName ? `${LastName}/${FirstName}` : `${LastName || ''}${FirstName || ''}`
      let name = ''
      if (ChName && EnName) {
        name = `${ChName}（${EnName}）`
      } else if (ChName || EnName) {
        name = `${ChName || ''}${EnName || ''}`
      } else {
        name = '--'
      }
      return name
    },
    showNickName() {
      return this.getSetting('常用配置:昵称:展示') || Number(this.TravelType) === 1
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.c-passenger-list-item
  @extends .flex-start
  align-items flex-start
  width calc(100% - 16px)
  min-height 96px
  padding 12px 16px 12px 0
  margin-left 16px
  background-color $color_white
  box-shadow 0px -0.5px 0px 0px $color_black_30 inset
  position relative
  overflow hidden
  >.passenger-info
    @extends .flex-start
    align-items flex-start
    width 100%
    >.checkbox
      width 24px
      height 24px
      background-size 100% 100%
      flex-shrink 0
      margin-right 8px
    >.details
      width 100%
      >.header
        @extend .flex-start
        width 100%
        margin-bottom 8px
        >.name
          @extend .hs-font-subtitle-big
          display inline-flex
          color $color_black_900
          >span
            ellipsis(1)
            font-weight 500
        >.mine
        >.staff
        >.no-staff
        >.children
        >.baby
          display inline-flex
          line-height normal
          padding 2px 5px
          border-radius 3px
          border: 0.5px solid rgba(227, 225, 225, 1)
          color $color_green_layer
          font-size 0.7rem
          background-color $color_green_background_0
          // margin-right 10px
          flex-shrink 0
          margin-left 4px
        >.no-staff, >.mine
          @extend .hs-font-caption-3
          border-radius 4px
          color $color_black_100
          background-color $color_black_0
          padding 0 4px
        >.children
          border: 0.5px solid rgba(227, 225, 225, 1)
          color $color_font_yellow_3
          background-color $color_background_theme_3
        >.baby
          border: 0.5px solid rgba(227, 225, 225, 1)
          color $color_font_blue_8
          background-color $color_background_blue_2
      >.item
        @extend .flex-row
        @extend .flex-start
        width 100%
        word-break break-all
        margin-bottom 4px
        &:last-child
          margin-bottom 0
        >div
          @extend .flex-start
          @extend .hs-font-caption-1
          color $color_black_100
          &:nth-child(1)
            width auto
          &:nth-child(2)
            width calc(100% - 90px)
      >.mark
        @extend .flex-start
        @extend .hs-font-caption-1
        color $color_yellow_300
        >.icon
          width 12px
          height 12px
          background-size 100% 100%
          background-repeat no-repeat
  >.item-edit
    width 24px
    height 24px
    background url(@/assets/image/personal-center/passengers/icons_24pt_edit.svg) no-repeat
    background-size 100% 100%
    margin-left 12px
    flex-shrink 0
</style>
